import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { initializeDatadog } from "./app/components/datadog-provider";

import {
  handleCaughtError,
  handleRecoverableError,
  handleUncaughtError,
} from "./lib/errors";

import { Router } from "./router";

// Needs to be imported here not in App to avoid flash of unstyled content
import "./main.css";

// Called here instead of App to ensure all errors and logs are recorded from the very beginning
initializeDatadog();

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement, {
  onUncaughtError: handleUncaughtError,
  onCaughtError: handleCaughtError,
  onRecoverableError: handleRecoverableError,
});

root.render(
  <StrictMode>
    <Router />
  </StrictMode>,
);
